/**
 * ApiUtils
 * From: 1.0.0
 *
 * @packageDocumentation
 */

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isFormData = (data: any): data is FormData =>
  data instanceof FormData;

// 必要無いかも
export function isNullOrUndefined<T>(
  obj: T | null | undefined
): obj is null | undefined {
  return typeof obj === 'undefined' || obj === null;
}

export type HTTPRequestMethod =
  | 'GET'
  | 'HEAD'
  | 'POST'
  | 'PUT'
  | 'DELETE'
  | 'CONNECT'
  | 'OPTIONS'
  | 'TRACE'
  | 'PATCH';
